import { render } from "./SubmenuTopKeywords.vue?vue&type=template&id=831261ec"
import script from "./SubmenuTopKeywords.vue?vue&type=script&lang=js"
export * from "./SubmenuTopKeywords.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__